// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-f0k","buttons":"styles_buttons__3AJQ3"};